import React from 'react'
import type { TutorialViewModel } from '../onboarding/tutorialMachine'

interface MatchTutorialProps {
  view: TutorialViewModel
  onSkip: () => void
  onDismiss: () => void
  onAckEnemy: () => void
  onAckMechanic?: () => void
}

/** Floating contextual callout — no full-screen opaque modal during play. */
export const MatchTutorial: React.FC<MatchTutorialProps> = ({
  view,
  onSkip,
  onDismiss,
  onAckEnemy,
  onAckMechanic
}) => {
  if (!view.active && !view.enemyIntro && !view.mechanicHint) return null

  const showDismiss =
    view.step === 'pathInfo' ||
    view.step === 'targeting' ||
    view.step === 'controlHint'

  return (
    <div className="match-tutorial" data-testid="match-tutorial" role="status">
      {view.active && (
        <div className="match-tutorial__card">
          <p className="match-tutorial__message">{view.message}</p>
          <div className="match-tutorial__actions">
            {showDismiss && (
              <button
                type="button"
                className="match-tutorial__btn"
                data-testid="tutorial-got-it"
                onClick={onDismiss}
              >
                GOT IT
              </button>
            )}
            {view.canSkip && (
              <button
                type="button"
                className="match-tutorial__btn match-tutorial__btn--skip"
                data-testid="tutorial-skip"
                onClick={onSkip}
              >
                SKIP
              </button>
            )}
          </div>
        </div>
      )}
      {view.enemyIntro && (
        <div className="match-tutorial__enemy" data-testid="tutorial-enemy-intro">
          <p className="match-tutorial__enemy-text">{view.enemyIntro}</p>
          <button
            type="button"
            className="match-tutorial__btn"
            data-testid="tutorial-enemy-ack"
            onClick={onAckEnemy}
          >
            OK
          </button>
        </div>
      )}
      {view.mechanicHint && (
        <div className="match-tutorial__enemy" data-testid="tutorial-mechanic-hint">
          <p className="match-tutorial__enemy-text">{view.mechanicHint}</p>
          <button
            type="button"
            className="match-tutorial__btn"
            data-testid="tutorial-mechanic-ack"
            onClick={onAckMechanic}
          >
            OK
          </button>
        </div>
      )}
    </div>
  )
}
